// extracted by mini-css-extract-plugin
export default {"SearchBarContainer":"Searchbar_SearchBarContainer__Sohdg","Autosuggest-input":"Searchbar_Autosuggest-input__BbADK"};